import { __awaiter, __generator, __values } from "tslib";
import { tryParse } from './experiments-data-utils';
import { isUrlOfExperiment, isValidScopeUrl } from './urlMap';
var ExperimentsRequestsCache = /** @class */ (function () {
    function ExperimentsRequestsCache() {
        this.urlMap = new Map();
        this.pendingUrlMap = new Map();
    }
    ExperimentsRequestsCache.prototype.addUrlRequest = function (url, promise) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.pendingUrlMap.set(url, promise);
                        return [4 /*yield*/, promise.then(function (response) { return _this.addUrlResponse(url, response); })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    ExperimentsRequestsCache.prototype.addUrlResponse = function (url, response) {
        this.urlMap.set(url, response);
    };
    ExperimentsRequestsCache.prototype.getUrlResponse = function (url) {
        return this.urlMap.get(url);
    };
    ExperimentsRequestsCache.prototype.getUrlRequest = function (url) {
        return this.pendingUrlMap.get(url);
    };
    ExperimentsRequestsCache.prototype.getExperimentValue = function (specName, useNewApi) {
        var e_1, _a;
        try {
            for (var _b = __values(this.urlMap.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                var url = _c.value;
                if (isUrlOfExperiment(url, specName, useNewApi)) {
                    return this.urlMap.get(url);
                }
                else if (isValidScopeUrl(url, useNewApi)) {
                    var jsonObject = tryParse(this.urlMap.get(url));
                    if (typeof jsonObject === 'object' && specName in jsonObject) {
                        return jsonObject[specName];
                    }
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
    };
    return ExperimentsRequestsCache;
}());
export { ExperimentsRequestsCache };
var NullCache = /** @class */ (function () {
    function NullCache() {
    }
    NullCache.prototype.addUrlRequest = function () { };
    NullCache.prototype.addUrlResponse = function () { };
    NullCache.prototype.getUrlResponse = function () {
        return undefined;
    };
    NullCache.prototype.getUrlRequest = function () {
        return undefined;
    };
    NullCache.prototype.getExperimentValue = function () {
        return undefined;
    };
    return NullCache;
}());
export { NullCache };
export function getCacheInstance() {
    if (process.env.NODE_ENV !== 'production') {
        return new NullCache();
    }
    /*
      Previously, we saved the global cache as `self.experimentsCache`.
      The global cache was later changed to support requests rather than responses.
      This meant we had to change its shape, which forced us to rename its global field
      because older versions were still running in production.
  
      Once everyone updates their `wix-experiments` version to using this new cache,
      we can go back to using `experimentsCache`.
    */
    if (self.experimentsCacheV2 === undefined) {
        self.experimentsCacheV2 = new ExperimentsRequestsCache();
    }
    return self.experimentsCacheV2;
}
//# sourceMappingURL=experiments-cache.js.map